import { createContext, useContext } from 'react';

export const UNMEASURED_PAGE_WIDTH = 0;

export const PageWidthContext = createContext<number>(UNMEASURED_PAGE_WIDTH);

export function usePageWidth(): number {
  return useContext(PageWidthContext);
}
